import React from 'react';
import "./Counter.css";
import CountUp from "react-countup";
import { FaBriefcase, FaTools, FaUsers, FaHandshake } from 'react-icons/fa';

const stats = [
  { id: 1, value: 8, suffix: '+', label: 'Yıl Tecrübe', icon: <FaBriefcase className="counter-icon" />, percent: 88, desc: 'Deneyimli teknisyenler' },
  { id: 2, value: 1500, suffix: '+', label: 'Servis', icon: <FaTools className="counter-icon" />, percent: 92, desc: 'Hızlı & güvenilir müdahale' },
  { id: 3, value: 1200, suffix: '+', label: 'Memnun müşteriler', icon: <FaUsers className="counter-icon" />, percent: 95, desc: 'Yüksek memnuniyet oranı' },
  { id: 4, value: 5, suffix: '', label: 'İş Ortağı', icon: <FaHandshake className="counter-icon" />, percent: 75, desc: 'Sektör iş birlikleri' },
];

const Counter = () => {
  return (
    <section className="counter-section" aria-labelledby="counter-heading">
      <h2 id="counter-heading" className="sr-only">İstatistiklerimiz</h2>
      <div className="counter-grid">
        {stats.map((s, i) => (
          <div
            key={s.id}
            className="counter-card"
            role="group"
            aria-label={`${s.label}: ${s.value}${s.suffix}`}
            style={{ animationDelay: `${i * 120}ms` }}
          >
            <div className="counter-icon-wrap" aria-hidden>{s.icon}</div>
            <div className="counter-value">
              <CountUp start={0} end={s.value} duration={2} separator="," suffix={s.suffix} />
            </div>
            <div className="counter-label">{s.label}</div>
            <div className="counter-desc" aria-hidden>{s.desc}</div>
            <div className="counter-progress" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow={s.percent}>
              <div className="counter-progress-fill" style={{ width: `${s.percent}%` }} />
            </div>
            <span className="sr-only" aria-live="polite">{s.value}{s.suffix} {s.label}</span>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Counter;